<template>
  <div>
    <!-- Calendar Icon -->
    <v-icon class="edit" color="#00a0e6" x-large @click.stop="openCalendar()">
      mdi-calendar-month
    </v-icon>

    <!-- Calendar Dialog -->
    <v-dialog v-model="showCalendar" width="500">
      <v-card>
        <!-- Close Button -->
        <v-card-title class="d-flex justify-space-between">
          <v-btn icon @click="closeCalendar" class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <!-- Title Bar (Same Width as Date Picker) -->
          <!-- <div class="v-picker2__title2">Custom Title</div> -->

          <!-- Date Picker          color="red" -->
          <v-date-picker
            :events="highlightDates"
            event-color="#e80814"
            readonly
            :min="minDate"
            :max="maxDate"
            @update:picker-date="onPickerDateUpdate"
          />
          <template #title>
            <div style="text-align: center">
              <div>التقويم</div>
              <div>الغياب : {{ absenceDays }} ايام</div>
              <div>{{ textHolder }}</div>
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      minDate: "", // First day of last month
      maxDate: "", // Last day of the current month
      showCalendar: false,
      playerAbsence: [], // Get player absence
      absenceDays: 0,
    };
  },
  props: ["textHolder", "playerID", "groupID"],
  methods: {
    openCalendar() {
      this.showCalendar = true;
    },
    closeCalendar() {
      this.showCalendar = false;
    },
    getPlayerAbsence() {
      // Get player attendance
      this.axios
        .get(`player-attendance`, {
          params: {
            player_id: this.playerID,
            group_id: this.groupID,
          },
        })
        .then((res) => {
          // console.log("Attendance", res.data.data);
          this.playerAbsence = res.data.data
            .filter((item) => item.is_present == 1)
            .map((item) => item.date);
          this.absenceDays = this.playerAbsence.length;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    highlightDates(date) {
      const highlightedDays = this.playerAbsence; // Replace with your specific dates
      return highlightedDays.includes(date);
      // const startDate = new Date(this.highlightedRange.start);
      // const endDate = new Date(this.highlightedRange.end);
      // const currentDate = new Date(date);
      // return currentDate >= startDate && currentDate <= endDate;
    },
    onPickerDateUpdate(date) {
      this.absenceDays = 0;
      // `date` is the currently displayed date in the picker
      const month = new Date(date).getMonth() + 1; // Months are 0-indexed, so add 1
      // this.currentMonth = month;
      // console.log(
      //   "playerAbsence",
      //   this.playerAbsence[0].split("-")[1] == month
      // );
      this.playerAbsence.filter((theDate) => {
        if (theDate.split("-")[1] == month) {
          this.absenceDays = this.absenceDays + 1;
        }
      });
      // console.log("Absence Days", this.absenceDays);
      // console.log("Currently Displayed Month:", month);
    },
    updateCalendarTitle() {
      const titleElement = document.querySelector(".v-picker__title");
      if (titleElement) {
        // Remove existing custom content
        const existingSpan = titleElement.querySelector(".custom-span");
        if (existingSpan) {
          titleElement.removeChild(existingSpan);
        }

        // Update the text
        const titleText = titleElement.innerText.split("\n")[0]; // Keep original title
        titleElement.innerText = `${titleText}
 ${this.$t("labels.absence")} : ${this.absenceDays} ${this.$t("labels.days")}`;
        // Add the custom span
        const myspan = document.createElement("span");
        myspan.innerText = this.textHolder;
        myspan.classList.add("custom-span");
        myspan.style.display = "block";
        myspan.style.textAlign = "center";
        titleElement.appendChild(myspan);
      }
    },
  },

  watch: {
    showCalendar(newVal) {
      if (newVal) {
        this.$nextTick(this.updateCalendarTitle);
      }
    },
    absenceDays() {
      if (this.showCalendar) {
        this.$nextTick(this.updateCalendarTitle);
      }
    },
  },
  created() {
    const today = new Date();
    // Get first day of previous month
    const firstDayOfLastMonth = new Date(
      today.getFullYear(),
      today.getMonth() - 1,
      1
    );
    this.minDate = firstDayOfLastMonth.toISOString().split("T")[0];

    // Get last day of the current month
    const lastDayOfCurrentMonth = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      0
    );
    this.maxDate = lastDayOfCurrentMonth.toISOString().split("T")[0];

    // console.log("mountedcalender", this.textHolder);
  },
  async mounted() {
    await this.getPlayerAbsence();
  },
};
</script>

<style scoped>
.v-picker__title {
  /* display: none; */
  background-color: #00a0e6 !important;
}
.v-application .red {
  background-color: #00a0e6 !important;
  border-color: #00a0e6 !important;
}

.close-btn {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
}
.v-card > *:first-child:not(.v-btn):not(.v-chip):not(.v-avatar),
.v-card > .v-card__progress + *:not(.v-btn):not(.v-chip):not(.v-avatar) {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  width: 100%;
}
.v-card-text {
  overflow: hidden !important;
  padding: 0 !important; /* Removes extra padding */
  max-height: 100% !important;
}

/* Ensure v-date-picker doesn't overflow */
.v-date-picker {
  overflow: hidden !important;
  margin: 0 !important;
  padding: 0 !important;
  max-height: 100%;
}
</style>
